import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { LanguageItem } from "../listing/LanguagesListing";

interface ILanguageListingContext {
    languageItems: LanguageItem[];
    isLoading: boolean;
    addLanguageItem(languageItem: LanguageItem): void;
}

const initialContextState: ILanguageListingContext = {
    languageItems: [],
    isLoading: false,
    addLanguageItem: contextFunctionInit
};

export const LanguageListingContext = createContext<ILanguageListingContext>(initialContextState);
